import util from '@bmp-vue/core/api/util'

const controller = 'ProtestoBoleto'

export default Object.assign({}, util.GetCrud(controller, null), {
  SolicitarProtesto: function (numCodBarrasList) {
    return util.Axios.Post(controller + '/solicitar', numCodBarrasList)
  },
  CancelarProtesto: function (numCodBarras) {
    return util.Axios.Post(controller + '/cancelar', numCodBarras)
  },
  SolicitarAnuencia: function (numCodBarras) {
    return util.Axios.Post(controller + '/informar-anuencia', numCodBarras)
  },
  SolicitarDesistencia: function (numCodBarras) {
    return util.Axios.Post(controller + '/informar-desistencia', numCodBarras)
  },
  DownloadArquivoHistoricoBoletoProtestado: function (codigoDeBarras) {
    return util.Axios.Get(controller + `/arquivo-historico-boleto-protestado/${codigoDeBarras}`)
  }
})
